module.exports = __webpack_public_path__ + "static/img/02student.7e9816ce.png";